export const COMPARISON_TABLE_BREAKPOINT_PX = 820;
export const COMPARISON_TABLE_BREAKPOINT = `${COMPARISON_TABLE_BREAKPOINT_PX}px`;

export const COMPARISON_TABLE_RADIUS = '16px';

export const AVAILABILITY_YES_COLOUR = '#006700';
export const AVAILABILITY_NEGATIVE_COLOUR = '#516272';
